import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/**
 * tailwind-merge must know the DS theme names, otherwise `text-logo-sm` would be read as a text
 * colour and silently drop `text-fg`, or `shadow-focus` as a shadow colour.
 */
const twMerge = extendTailwindMerge<'ds-type'>({
  extend: {
    classGroups: {
      'font-size': [{ text: ['3xs', '2xs', 'tile', 'logo-sm', 'logo-lg'] }],
      shadow: [{ shadow: ['page', 'focus', 'focus-danger'] }],
      'ds-type': [
        {
          type: ['display', 'h1', 'h2', 'h3', 'body', 'body-lg', 'label', 'caption', 'overline', 'mono', 'page'],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
